import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui";
import ClientShipmentView from "../../../components/shipments/ClientShipmentView";
import type { ClientShipmentUnit } from "../../../components/shipments/ClientShipmentView";
import { shipmentPosition, type Shipment } from "../../../features/shipments/types";
import { useShipmentUnit } from "../hooks/useShipmentUnit";

interface ClientViewPanelProps {
  shipment: Shipment;
}

export default function ClientViewPanel({ shipment }: ClientViewPanelProps) {
  const { t } = useTranslation("envios");
  const navigate = useNavigate();
  const unit = useShipmentUnit(shipment.actual_device_id);

  const historyPosition = shipmentPosition(shipment);
  const position =
    unit && unit.latitude !== null && unit.longitude !== null
      ? { lat: unit.latitude, lng: unit.longitude }
      : historyPosition
        ? { lat: historyPosition.lat, lng: historyPosition.long }
        : null;

  const trackingUnit: ClientShipmentUnit | null =
    unit && position
      ? {
          id: unit.deviceId,
          name: unit.name,
          latitude: position.lat,
          longitude: position.lng,
          status: unit.status,
        }
      : null;

  return (
    <ClientShipmentView
      clientName={shipment.client_name}
      trackingNumber={shipment.tracking_number}
      originAddress={shipment.origin.address}
      destinationAddress={shipment.destination.address}
      events={shipment.event_history}
      unit={trackingUnit}
      header={
        <Button
          variant="outline"
          size="sm"
          icon={<i className="ri-arrow-left-line" />}
          onClick={() => navigate(-1)}
          className="mb-4"
        >
          {t("detail.backToPanel")}
        </Button>
      }
    />
  );
}
